import React from 'react';
import T from 'prop-types';

import SimpleDropdown from './Dropdowns/SimpleDropdown';
import { periodChangeTypeOptions } from '../utils/change-types';

const OverPeriodDropdown = ({
  selected,
  disabled,
  menuAlign,
  optionClassName = '',
  appendOptions,
  valueDecorator,
  onChange,
}) => {
  const typeOptions = periodChangeTypeOptions.concat(appendOptions || []).map((option) => ({
    ...option,
    className: optionClassName,
  }));

  const options = valueDecorator
    ? typeOptions.map((option) => ({ ...option, value: valueDecorator(option.value) }))
    : typeOptions;

  return (
    <SimpleDropdown
      selected={selected}
      options={options}
      disabled={disabled}
      isActiveSelectable={false}
      menuWidth={221}
      menuAlign={menuAlign}
      onChange={onChange}
    />
  );
};

OverPeriodDropdown.propTypes = {
  selected: T.string.isRequired,
  disabled: T.bool,
  menuAlign: T.string,
  optionClassName: T.string,
  appendOptions: T.arrayOf(
    T.shape({
      label: T.string,
      value: T.string,
    })
  ),
  valueDecorator: T.func,
  onChange: T.func.isRequired,
};

export default OverPeriodDropdown;
